
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/[...slug]",
      function () {
        return require("private-next-pages/en/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/[...slug]"])
      });
    }
  